import MuiDialog, {DialogProps as MuiDialogProps} from '@mui/material/Dialog';
import React, {memo} from 'react';
import {DialogTitle} from './DialogTitle';
import {DialogContent} from './DialogContent';

export type DialogProps = {
   close?: () => void;
   open?: boolean;
   children?: React.ReactNode;
   header?: React.ReactNode;
   maxWidth?: MuiDialogProps['maxWidth'];
   fullWidth?: MuiDialogProps['fullWidth'];
   // classes?: MuiDialogProps['classes'];
   TransitionComponent?: MuiDialogProps['TransitionComponent'];
};

const Dialog = memo((props: DialogProps) => {
   const {
      close,
      open = true,
      header,
      maxWidth,
      children,
      fullWidth = true,
      TransitionComponent,
   } = props;

   const onClose = React.useCallback(
      (_?: unknown, reason?: string) => {
         if (reason !== 'backdropClick') close?.();
      },
      [close]
   );

   return (
      <MuiDialog
         onClose={onClose}
         maxWidth={maxWidth}
         fullWidth={fullWidth}
         open={open}
         classes={{
            paper: 'no-border-paper',
         }}
         TransitionComponent={TransitionComponent}
      >
         <DialogTitle id="customized-dialog-title" onClose={onClose}>
            {header}
         </DialogTitle>

         <DialogContent dividers>{children}</DialogContent>
      </MuiDialog>
   );
});

export default Dialog;
